import React from 'react';
import './AlertsPanel.css';

function AlertsPanel({ alertas }) {
  if (!alertas || alertas.length === 0) {
    return (
      <div className="alerts-panel no-alerts">
        <h4>
          <span className="material-symbols-outlined" style={{ fontSize: '14px', verticalAlign: 'text-bottom' }}>check_circle</span> Validações Automáticas
        </h4>
        <p>Todos os dados necessários foram fornecidos.</p>
      </div>
    );
  }

  // TD86-frontend: normalize severidade — fallbacks IA (backend ai_service.py:1798,
  // 1988) gravam 'Alta' Capitalized; sem normalize aqui esses alertas críticos
  // ficavam invisíveis no painel. Simetria cross-stack com TD-133 backend
  // (validation_service.calcular_score_qualidade já normaliza desde Sessão 12).
  // Aceita variantes de case + acento ('média'/'media') por defesa adicional.
  const sevOf = (a) => {
    const raw = (a?.severidade || '').toString().trim().toLowerCase();
    if (raw === 'média') return 'media';
    return raw;
  };
  const alertasAlta  = alertas.filter(a => sevOf(a) === 'alta');
  const alertasMedia = alertas.filter(a => sevOf(a) === 'media');
  const alertasBaixa = alertas.filter(a => sevOf(a) === 'baixa');

  const renderGroup = (items, sev, label) => {
    if (!items.length) return null;
    return (
      <div className="alerts-group" key={sev}>
        <h5 className={`severity-title ${sev}`}>{label} ({items.length})</h5>
        {items.map((alerta, idx) => (
          <div key={idx} className={`alert-item ${sev}`}>
            <span className="alert-dot" />
            <span className="alert-mensagem">{alerta.mensagem}</span>
            <span className="alert-severity-tag">
              {sev === 'alta' ? 'High' : sev === 'media' ? 'Medium' : 'Low'}
            </span>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="alerts-panel">
      <div className="alerts-header">
        <h4>Validações Automáticas</h4>
        <span className="alerts-count">{alertas.length}</span>
      </div>

      {renderGroup(alertasAlta,  'alta',  'Severidade Alta')}
      {renderGroup(alertasMedia, 'media', 'Severidade Média')}
      {renderGroup(alertasBaixa, 'baixa', 'Severidade Baixa')}

      <div className="alerts-footer">
        <p>
          <span className="material-symbols-outlined" style={{ fontSize: '13px', verticalAlign: 'text-bottom' }}>lightbulb</span> Forneça mais informações para aumentar o score de qualidade
        </p>
      </div>
    </div>
  );
}

export default AlertsPanel;
